module.exports = __webpack_public_path__ + "1.4.15-unryo/img/offline-collector-4.5f4c0520.svg";